import { Component } from 'react';

const EVENT_TRIGGER = 'keydown';

interface Props {
  onKey: (e: KeyboardEvent) => void;
}
/**
 * WARNING! I suspect the greedy listeners below aren't performance friendly, but
 * wasn't able to find a React 16 friendly replacement that followed the same pattern.
 * todo: INVESTIGATE AND FIX IF NEEDED
 */
export default class HotKeyTrap extends Component<Props> {
  componentDidMount() {
    document.addEventListener(EVENT_TRIGGER, this.props.onKey);
  }
  shouldComponentUpdate(nextProps: Props) {
    return nextProps.onKey !== this.props.onKey;
  }

  componentDidUpdate(prevProps: Props) {
    document.removeEventListener(EVENT_TRIGGER, prevProps.onKey);
    document.addEventListener(EVENT_TRIGGER, this.props.onKey);
  }
  componentWillUnmount() {
    document.removeEventListener(EVENT_TRIGGER, this.props.onKey);
  }

  render() {
    return null;
  }
}
